export default __webpack_public_path__ + "static/media/mr_mrs_smith_xl1.ebdc40f4.png";